import {Fragment as _Fragment, jsx as _jsx, jsxs as _jsxs} from "react/jsx-runtime";
import {useMDXComponents as _provideComponents} from "@mdx-js/react";
import {Viewport} from "..";
function _createMdxContent(props) {
  const _components = {
    a: "a",
    code: "code",
    h1: "h1",
    h2: "h2",
    p: "p",
    ..._provideComponents(),
    ...props.components
  };
  return _jsxs(_Fragment, {
    children: [_jsx(_components.h1, {
      children: "Viewport"
    }), "\n", _jsxs(_components.p, {
      children: ["The ", _jsx(_components.code, {
        children: "<Viewport>"
      }), " component is a full-width component which is a lightly interactive wrapper around an ", _jsx(_components.code, {
        children: "<iframe>"
      }), ".\nThe viewport can be resized to simulate different device widths. The height of the iframe will automatically adjust\nto the iframe content."]
    }), "\n", _jsx(_components.p, {
      children: "The component does not provide the full functionality of the browsers responsive device mode simulation. In particular,\nit can't simulate network / CPU throttling, nor can it change the user agent. It's purpose is to provide a simple\ninterface to test your components at different viewport widths."
    }), "\n", _jsxs(_components.p, {
      children: ["Since ", _jsx(_components.code, {
        children: "<Viewport>"
      }), " uses an ", _jsx(_components.code, {
        children: "<iframe>"
      }), ", you must provide a page which can be loaded into it. If you used the timvir\ncli to scaffold your component, you already have one such sample (in ", _jsx(_components.code, {
        children: "src/components/…/samples/basic.tsx"
      }), "). Make that\nsample available via a Next.js page and load it into the ", _jsx(_components.code, {
        children: "<Viewport>"
      }), "."]
    }), "\n", _jsxs(_components.p, {
      children: ["See also ", _jsx(_components.a, {
        href: "/concepts/component-sample",
        children: "Concepts: Component Sample"
      }), "."]
    }), "\n", _jsx(Viewport, {
      src: "/docs/components/Grid/samples/basic"
    }), "\n", _jsx(_components.h2, {
      children: "Loading Behaviour"
    }), "\n", _jsxs(_components.p, {
      children: ["The ", _jsx(_components.code, {
        children: "<Viewport>"
      }), " displays a gray, animated background while the iframe is loading."]
    }), "\n", _jsx(Viewport, {
      src: "/api/slow"
    }), "\n", _jsx(_components.h2, {
      children: "Unsupported content"
    }), "\n", _jsx(_components.p, {
      children: "When the Viewport points to something else than a HTML document (eg. an image), it'll\nstay the default height, but display the contents nonetheless."
    }), "\n", _jsx(_components.p, {
      children: "TODO: display a nice error message describing the problem."
    }), "\n", _jsx(Viewport, {
      src: "/assets/image.jpg"
    })]
  });
}
export default function MDXContent(props = {}) {
  const {wrapper: MDXLayout} = {
    ..._provideComponents(),
    ...props.components
  };
  return MDXLayout ? _jsx(MDXLayout, {
    ...props,
    children: _jsx(_createMdxContent, {
      ...props
    })
  }) : _createMdxContent(props);
}
